import { IThemeContext } from './interfaces';
export const initState: IThemeContext = {
  colors: {},
  dropdownVisible: false,
  isInBackground: false,
  minTimeResolution: '15minute',
  breakpoint: 'lg',

};
